import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { BACKEND_URL } from '../Constants';

const TranscriptPage = () => {
  const { studentEmail } = useParams();
  const [scores, setScores] = useState([]);
  const [studentName, setStudentName] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchTranscript() {
      try {
        const enrollments = await axios.get(`${BACKEND_URL}/api/enrollments/all-quiz-scores`);
        const chatbot = await axios.get(`${BACKEND_URL}/api/quiz-progress/all`);
        const allScores = [...enrollments.data, ...chatbot.data];

        const filtered = allScores.filter(s => s.studentEmail === decodeURIComponent(studentEmail));
        setScores(filtered);
        if (filtered.length > 0) {
          setStudentName(filtered[0].studentName || 'Unnamed');
        } else {
          setError('No transcript data found for this student.');
        }
      } catch (err) {
        console.error('Error fetching transcript:', err);
        setError('Failed to load transcript.');
      } finally {
        setLoading(false);
      }
    }

    fetchTranscript();
  }, [studentEmail]);

  const average = scores.length
    ? (scores.reduce((sum, s) => {
        const pct = s.maxScore > 0 ? (s.score / s.maxScore) * 100 : 0;
        return sum + pct;
      }, 0) / scores.length).toFixed(2)
    : 'N/A';

  if (loading) return <p className="text-muted fs-5">Loading transcript...</p>;
  if (error) return <div className="alert alert-danger">{error}</div>;

  return (
    <div className="container py-4" style={{ fontFamily: 'Arial, sans-serif' }}>
      <h2>Student Transcript</h2>
      <p><strong>Name:</strong> {studentName}</p>
      <p><strong>Email:</strong> {decodeURIComponent(studentEmail)}</p>
      <p><strong>Total Quizzes Taken:</strong> {scores.length}</p>
      <p><strong>Average Score:</strong> {average}%</p>

      <table className="table table-bordered mt-4">
        <thead className="table-light">
          <tr>
            <th>Chapter Title</th>
            <th>Quiz Title</th>
            <th>Score</th>
            <th>Max Score</th>
            <th>Percentage</th>
            <th>Date Taken</th>
          </tr>
        </thead>
        <tbody>
          {scores.map((s, i) => {
            const pct = s.maxScore > 0 ? ((s.score / s.maxScore) * 100).toFixed(2) : 'N/A';
            return (
              <tr key={i}>
                <td>{s.courseTitle}</td>
                <td>{s.quizTitle}</td>
                <td>{s.score}</td>
                <td>{s.maxScore}</td>
                <td>{pct}%</td>
                <td>{new Date(s.dateTaken).toLocaleDateString()}</td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <button className="btn btn-outline-secondary mt-3" onClick={() => window.print()}>
        Print Transcript
      </button>
    </div>
  );
};

export default TranscriptPage;
